import React from 'react';
import {convertISODateTimeToBRLocale} from "../../../common/Util";
import AutoclaveCicloGraficoIndicadores from "../Ciclo/AutoclaveCicloGraficoIndicadores";
import Paper from "@material-ui/core/Paper/Paper";
import Grid from "@material-ui/core/Grid/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import Icon from "@material-ui/core/Icon/Icon";
import {connect} from "react-redux";
import {getAutoclaveCicloSubCiclo, getAutoclaveHistoricoIndicadores} from "../../../actions/autoclaveActions";
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import EventoCP from "../../../components/eventoCP";
import AlarmeCP from "../../../components/alarmeCP";
import Button from "@material-ui/core/Button";
import {Link} from "react-router-dom";




const ReactHighcharts = require('react-highcharts');
//var Moment = require('moment-timezone');
//require('moment/locale/pt-br');

function pad(num, size) {
    var s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
}

const styles = theme => ({
    dashboardSection: {
        marginTop: "50px"
    },
    typoTitle: {
        fontSize: '0.6rem'
    },
    sectionTitle: {
        marginBottom: theme.spacing(1) * 4,
        marginTop: theme.spacing(1) * 4
    },
    chartGrid: {
        textAlign: 'center',
        padding: "10px",
        //  marginBottom: "20px"
    },

    rootEstadoMandril: {
        display: 'flex'
    },
    gridContainerEstadoMandril: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: theme.spacing(3),
    },
    gridEstadoMandril:{
        borderWidth: '1px',

    },
    paperEstadoMandril: {
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        whiteSpace: 'nowrap',
        marginBottom: theme.spacing(1),
    },
    imgRaspa: {
        width: '100%',
        height: '100%'
    },
    backgroundRed: {
        backgroundColor: 'red'
    }
})




class AutoclaveRealTimeInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            dados: {},
            loading: false,
            loadingsubciclo: false,
            ultimaCarga: 0,
            numAtualizacao: 0
        };
    };


    componentDidMount(){
    }



    componentDidUpdate(prevProps, prevState, snapShot){




      //  debugger;
        if (
            (!this.props.autoclaves.isFetchingAutoclaveCicloIndicadores) &&
            (this.state.numAtualizacao !== this.props.autoclaves.numAtualizacao)
        ) {

            console.log("chamar if inside props");

            this.setState({

                numAtualizacao: this.props.autoclaves.numAtualizacao,
                ultimaCarga: new Date(),
                loading: false
            })
        }

        console.log("subsciclo", this.props.autoclaves.AutoclavesSubCiclo)

        if (JSON.stringify(this.props.autoclaveRealTime) != JSON.stringify(prevProps.autoclaveRealTime)) {
            this.setState( {
                dados: {
                    ...this.state.dados,
                    ...this.props.autoclaveRealTime
                }
            })
        }

        //dados para render graficos
        if ( this.props.autoclaveRealTime.ProcessoIniciado && !this.props.autoclaves.isFetchingAutoclaveCicloIndicadores && !this.state.loading ) {
            if  ( ( new Date().getTime() - new Date(this.state.ultimaCarga).getTime()) > (1000 * 30)  ) {

                const isc =  this.props.autoclaves.AutoclavesSubCiclo.find(c => c.autoclaveId === this.props.autoclaveRealTime.autoclaveId);
                if (isc) {
                    //console.log("CHAMAR getAutoclaveHistoricoIndicadores", this.props.autoclaveRealTime.autoclaveId, isc.ciclo, isc.subciclo )
                    this.props.getAutoclaveHistoricoIndicadores(this.props.autoclaveRealTime.autoclaveId, isc.ciclo + isc.subciclo) //this.props.autoclaveRealTime.ciclo);
                    if (isc && isc.ciclo && isc.subciclo) {
                        this.setState({
                            loading: true,
                            ultimaCarga: new Date(),
                            loadingsubciclo: false,
                            ciclo: isc.ciclo,
                            subciclo: isc.subciclo
                        })
                    }
                } else {
                    if (!this.state.loadingsubciclo) {
                        //console.log("call subsciclos action")
                        this.props.getAutoclaveCicloSubCiclo(this.props.autoclaveRealTime.autoclaveId)
                        this.setState({loadingsubciclo: true})
                    }
                }

            }
        }

    }




    render() {
        const { autoclaveRealTime, classes, mais } = this.props;
        const { isOpen, graficos } = this.state;

        const aRT = this.state.dados;

         //console.log("indicador ciclo", this.state,  this.props.autoclaveRealTime);

        let situacao = 'PARADA';
        if (aRT.ProcessoIniciado == null) { situacao = '---------'; }
        if (aRT.ProcessoIniciado) { situacao = 'AQUECIMENTO'; }
        if (aRT.ProcessoIniciado && (aRT.EfetivoTempoVulcanizacao >0) ) { situacao = 'VULCANIZAÇÃO'; }
        if (aRT.FimDeCiclo) { situacao = 'FINALIZANDO'; }


        let percentual = 0;
        if ((aRT.EfetivoTempoVulcanizacao > 0) && (aRT.PresetTempoVulcanizacao > 0)) {
            percentual = Math.round(aRT.EfetivoTempoVulcanizacao / aRT.PresetTempoVulcanizacao * 100);
        }

        let horaInicio = '--:--';
        let horaFim = '--:--'
        if (aRT.HoraInicial >= 0) {
            horaInicio = pad(aRT.HoraInicial, 2) + ':' + pad(aRT.MinutoInicial, 2);
        }
        if (aRT.HoraFinal >= 0) {
            horaFim = pad(aRT.HoraFinal, 2) + ':' + pad(aRT.MinutoFinal, 2);
        }




        const a = this.props.autoclaves.Autoclaves.find(a => a.id === aRT.autoclaveId);

       // console.log("mqtt realtime", a, aRT);

        console.log("AutoclaveRealTimeInfo", this.state.ciclo, this.state.subciclo, aRT);

        let ciclo =  0;
        if (typeof(aRT.ciclo) !==  "undefined") {
            ciclo =  aRT.ciclo;
        }
        if (typeof(this.state.ciclo) !== "undefined" && typeof(this.state.subciclo) !== "undefined") {
            ciclo = this.state.ciclo + this.state.subciclo
        }

        const dmais = (
            <React.Fragment>
                <Grid container style={{ alignItems:'stretch', padding: '2px' }}>
                    <Grid item  xs={3} sm={3} md={3} lg={3} xl={3} style={{ alignItems:'stretch', padding: '2px' }}>
                        <Paper>
                            <Grid container direction="column">
                                <Grid item>
                                    <Typography className={classes.typoTitle} variant="caption">SCANS</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography className={classes.typoTitle} variant="caption">{aRT.contadorScans}</Typography>
                                </Grid>

                            </Grid>
                        </Paper>
                    </Grid>
                    <Grid item  xs={9} sm={9} md={9} lg={9} xl={9} style={{ alignItems:'stretch', padding: '2px'}}>
                        <Paper style={{ alignItems:'stretch', height: '100%' }}>
                            <Grid container direction="column">
                                <Grid item>
                                    <Typography className={classes.typoTitle} variant="caption">Ultima captura</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography className={classes.typoTitle} variant="caption">{convertISODateTimeToBRLocale(aRT.dtUltimoInsertDB,true)}</Typography>
                                </Grid>

                            </Grid>

                        </Paper>
                    </Grid>
                </Grid>
            </React.Fragment>
        )



        return (
            <React.Fragment>
                <Grid container xs={12} sm={12} md={12} lg={4} xl={4} style={{  padding: '2px'}} >
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ padding:'2px', minWidth: '310px' }} >

                        <Grid container style={{ alignItems:'stretch', padding: '2px' }}>
                           <Grid item  xs={3} sm={3} md={3} lg={3} xl={3} style={{ alignItems:'stretch', padding: '2px' }}>
                               <Paper>
                                   <Grid container direction="column">
                                       <Grid item>
                                           <Typography className={classes.typoTitle} variant="caption">AUTOCLAVE</Typography>
                                       </Grid>
                                       <Grid item>
                                           <Typography variant="h4">{a? a.codigo : aRT.autoclaveId}</Typography>
                                       </Grid>

                          </Grid>
                               </Paper>
                           </Grid>
                            <Grid item  xs={9} sm={9} md={9} lg={9} xl={9} style={{ alignItems:'stretch', padding: '2px'}}>
                                <Paper style={{ alignItems:'stretch', height: '100%' }}>
                                    <Grid container direction="column"  >
                                        <Grid item>
                                            <Typography className={classes.typoTitle} variant="caption">SITUAÇÃO</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="h6">{situacao}</Typography>
                                        </Grid>

                                    </Grid>

                                </Paper>
                            </Grid>
                        </Grid>
                        <Grid container style={{ alignItems:'stretch', padding: '2px', justifyContent: 'space-between' }}>
                            <Grid item  xs={4} sm={4} md={4} lg={4} xl={4} style={{ alignItems:'stretch', padding: '2px' }}>
                                <Paper>
                                    <Grid container direction="column">
                                        <Grid item>
                                             <Typography className={classes.typoTitle} variant="caption">CICLO</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="h4">{ciclo}</Typography>
                                        </Grid>
                                    </Grid>


                                </Paper>
                            </Grid>
                            <Grid item  xs={4} sm={4} md={4} lg={4} xl={4} style={{ alignItems:'stretch', padding: '2px' }}>
                                <Paper>
                                    <Grid container direction="column">
                                        <Grid item>
                                            <Typography className={classes.typoTitle}  variant="caption">RECEITA</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="h4">{aRT.ReceitaNumero > 0 ? aRT.ReceitaNumero : '--'}</Typography>
                                        </Grid>
                                        <Grid item style={{ alignContent:'right' }}>
                                            <Typography variant="subtitle1"></Typography>
                                        </Grid>
                                    </Grid>

                                </Paper>
                            </Grid>
                            <Grid item  xs={4} sm={4} md={4} lg={4} xl={4} style={{ alignItems:'stretch', padding: '2px' }}>
                                <Paper>
                                    <Grid container direction="column">
                                        <Grid item>
                                            <Typography className={classes.typoTitle} variant="caption">CONCLUSÃO</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="h4">{percentual}%</Typography>
                                        </Grid>

                                    </Grid>

                                </Paper>
                            </Grid>
                        </Grid>
                        <Grid container style={{ alignItems:'stretch', padding: '2px', justifyContent: 'space-between' }}>
                            <Grid item  xs={4} sm={4} md={4} lg={4} xl={4} style={{ alignItems:'stretch', padding: '2px' }}>
                                <Paper>
                                    <Grid container direction="column">
                                        <Grid item>
                                            <Typography className={classes.typoTitle} variant="caption">HORA INICIAL</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="h4">{horaInicio}</Typography>
                                        </Grid>
                                        <Grid item style={{ alignContent:'right' }}>
                                            <Typography variant="subtitle1">do ciclo</Typography>
                                        </Grid>
                                    </Grid>

                                </Paper>
                            </Grid>
                            <Grid item  xs={4} sm={4} md={4} lg={4} xl={4} style={{ alignItems:'stretch', padding: '2px' }}>
                                <Paper>
                                    <Grid container direction="column">
                                        <Grid item>
                                            <Typography className={classes.typoTitle} variant="caption">TEMPO VULC.</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="h4">{aRT.EfetivoTempoVulcanizacao}</Typography>
                                        </Grid>
                                        <Grid item style={{ alignContent:'right' }}>
                                            <Typography variant="subtitle1">{aRT.PresetTempoVulcanizacao} min</Typography>
                                        </Grid>
                                    </Grid>

                                </Paper>
                            </Grid>

                            <Grid item  xs={4} sm={4} md={4} lg={4} xl={4} style={{ alignItems:'stretch', padding: '2px' }}>
                                <Paper>
                                    <Grid container direction="column">
                                        <Grid item>
                                            <Typography className={classes.typoTitle} variant="caption">HORA FINAL</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="h4">{horaFim}</Typography>
                                        </Grid>
                                        <Grid item style={{ alignContent:'right' }}>
                                            <Typography variant="subtitle1">previsão</Typography>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Grid>
                        <Grid container style={{ alignItems:'stretch', padding: '2px' }}>
                            <Grid item  xs={3} sm={3} md={3} lg={3} xl={3} style={{ alignItems:'stretch', padding: '2px' }}>
                                <Paper>
                                    <Grid container direction="column">
                                        <Grid item>
                                            <Typography className={classes.typoTitle} variant="caption">AUTOCLAVE</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="h4">{aRT.EfetivoPressao}</Typography>
                                        </Grid>
                                        <Grid item style={{ alignContent:'right' }}>
                                            <Typography variant="subtitle1">{aRT.PresetPressaoAutoclave} psi</Typography>
                                        </Grid>
                                    </Grid>

                                </Paper>
                            </Grid>
                            <Grid item  xs={3} sm={3} md={3} lg={3} xl={3} style={{ alignItems:'stretch', padding: '2px' }}>
                                <Paper>
                                    <Grid container direction="column">
                                        <Grid item>
                                            <Typography className={classes.typoTitle} variant="caption">ENVELOPE</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography  variant="h4">{aRT.EfetivoPressaoEnvelope}</Typography>
                                        </Grid>
                                        <Grid item style={{ alignContent:'right' }}>
                                            <Typography variant="subtitle1">{aRT.PresetPressaoEnvelope} psi</Typography>
                                        </Grid>
                                    </Grid>

                                </Paper>
                            </Grid>
                            <Grid item  xs={3} sm={3} md={3} lg={3} xl={3} style={{ alignItems:'stretch', padding: '2px' }}>
                                <Paper>
                                    <Grid container direction="column">
                                        <Grid item>
                                            <Typography className={classes.typoTitle} variant="caption">SACO AR</Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography  variant="h4">{aRT.EfetivoPressaoSacoDeAr}</Typography>
                                        </Grid>
                                        <Grid item style={{ alignContent:'right' }}>
                                            <Typography variant="subtitle1">{aRT.PresetPressaoSacoDeAr} psi</Typography>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid item  xs={3} sm={3} md={3} lg={3} xl={3} style={{ alignItems:'stretch', padding: '2px' }}>
                                <Paper>
                                    <Grid container direction="column">
                                    <Grid item>
                                        <Typography className={classes.typoTitle} variant="caption">TEMPERATURA</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography  variant="h4">{Math.round(aRT.EfetivoTemperatura)?Math.round(aRT.EfetivoTemperatura): ''}</Typography>
                                    </Grid>
                                    <Grid item style={{ alignContent:'right' }}>
                                        <Typography variant="subtitle1">{Math.round(aRT.PresetTemperaturaAutoclave)? Math.round(aRT.PresetTemperaturaAutoclave): ''} C</Typography>
                                    </Grid>
                                </Grid>

                                </Paper>
                            </Grid>

                        </Grid>


                        {/*<Grid container style={{ alignItems:'stretch', padding: '4px' }}>*/}
                            {/*<Grid item>*/}
                                {/*<Icon className="fa fa-plus-circle" color="action" />*/}
                                {/*<Typography>teste</Typography>*/}
                            {/*</Grid>*/}
                        {/*</Grid>*/}

                        <Grid container style={{ alignItems:'stretch', padding: '2px' }}>

                            <Grid item  xs={3} sm={3} md={3} lg={3} xl={3} style={{ alignItems:'stretch', padding: '2px' }}>
                                <Paper>
                                    <Grid container direction="column">
                                        <Grid item>
                                            <Typography className={classes.typoTitle} variant="caption"></Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography  variant="h3"></Typography>
                                        </Grid>
                                        <Grid item style={{ alignContent:'right' }}>
                                            <Typography variant="subtitle1"></Typography>
                                        </Grid>
                                    </Grid>

                                </Paper>
                            </Grid>
                            <Grid item  xs={3} sm={3} md={3} lg={3} xl={3} style={{ alignItems:'stretch', padding: '2px' }}>
                                <Paper>
                                    <Grid container direction="column">
                                        <Grid item>
                                            <Typography className={classes.typoTitle}  variant="caption"></Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography  variant="h3"></Typography>
                                        </Grid>
                                        <Grid item style={{ alignContent:'right' }}>
                                            <Typography variant="subtitle1"></Typography>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid item  xs={3} sm={3} md={3} lg={3} xl={3} style={{ alignItems:'stretch', padding: '2px' }}>
                                <Paper>
                                    <Grid container direction="column">
                                        <Grid item>
                                            <Typography className={classes.typoTitle} variant="caption"></Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography  variant="h3"></Typography>
                                        </Grid>
                                        <Grid item style={{ alignContent:'right' }}>
                                            <Typography variant="subtitle1"></Typography>
                                        </Grid>
                                    </Grid>

                                </Paper>
                            </Grid>

                        </Grid>
                        {mais? dmais  : <React.Fragment/>}

                        <Grid container style={{ alignItems:'stretch', padding: '2px' }}>
                            <Paper>
                                <Grid container direction="column" style={{ flex: 1, flexDirection: 'row'}}>
                                    {/*    <EventoCP label={"Iniciado"} status={aRT.processoIniciado}/>*/}
                                    <EventoCP label={"Finalizando"} status={aRT.FimDeCiclo}/>
                                    <EventoCP label={"Ar Autoclave"} status={aRT.AlimentacaoArAutoclave}/>
                                    <EventoCP label={"Ar Envelope"} status={aRT.AlimentacaoEnvelope}/>
                                    <EventoCP label={"Ar Saco de Ar"} status={aRT.AlimentacaoSacoDeAr}/>
                                    <EventoCP label={"Vapor"} status={aRT.AlimentacaoVapor}/>
                                    <EventoCP label={"Descarga Ar"} status={aRT.DescargaDeAr}/>
                                    <EventoCP label={"Descarga Envelope"} status={aRT.DescargaEnvelope}/>
                                    <EventoCP label={"Descarga Saco de Ar"} status={aRT.DescargaSacoDeAr}/>
                                    <EventoCP label={"Ventilação"} status={aRT.Ventilador}/>

                                    <AlarmeCP label={"Sem Comunicacao"} status={aRT.AlarmeSemComunicacao}/>
                                    <AlarmeCP label={"Emergencia"} status={aRT.AlarmeEmergencia}/>
                                    <AlarmeCP label={"PT-100"} status={aRT.AlarmePT100}/>
                                    <AlarmeCP label={"Falta de Energia"} status={aRT.AlarmeFaltaEnergia}/>
                                    <AlarmeCP label={"Ventilação"} status={aRT.AlarmeVentilador}/>
                                    <AlarmeCP label={"Supervisao Pressao Autoclave"} status={aRT.AlarmeVentilador}/>
                                    <AlarmeCP label={"Supervisao Pressao Saco de Ar"} status={aRT.AlarmeSupervisaoPressaoSacoDeAr}/>
                                    <AlarmeCP label={"Supervisao Pressao Envelope"} status={aRT.AlarmeSupervisaoPressaoEnvelope}/>
                                    <AlarmeCP label={"Supervisao Aquecimento"} status={aRT.AlarmeSupervisaoAquecimento}/>
                                    <AlarmeCP label={"Temperatura Baixa"} status={aRT.AlarmeTemperaturaBaixa}/>
                                    <AlarmeCP label={"Temperatura Alta"} status={aRT.AlarmeTemperaturaAlta}/>
                                    <AlarmeCP label={"Pressao Alta Saco de Ar"} status={aRT.AlarmePressaoAltaSacoDeAr}/>
                                    <AlarmeCP label={"Pressao Alta Envelope"} status={aRT.AlarmePressaoAltaEnvelope}/>
                                    <AlarmeCP label={"Pressao Baixa Autoclave"} status={aRT.AlarmePressaoBaixa}/>
                                    <AlarmeCP label={"Pressao Alta Autoclave"} status={aRT.AlarmePressaoAlta}/>
                                    <AlarmeCP label={"Pressao Baixa Saco de Ar"} status={aRT.AlarmePressaoBaixaSacoDeAr}/>
                                    <AlarmeCP label={"Pressao Baixa Envelope"} status={aRT.AlarmePressaoBaixaEnvelope}/>
                                    <AlarmeCP label={"Falha Sensor Pressao Autoclave"} status={aRT.AlarmeFalhaSensorAutoclave}/>
                                    <AlarmeCP label={"Falha Sensor Saco de Ar"} status={aRT.AlarmeFalhaSensorSacoDeAr}/>
                                    <AlarmeCP label={"Falha Sensor Envelope"} status={aRT.AlarmeFalhaSensorEnvelope}/>
                                    <AlarmeCP label={"Falha Acionamento Ventilação"} status={aRT.AlarmeFalhaAcionamentoVentilador}/>
                                    <AlarmeCP label={"Trip Aquecimento"} status={aRT.AlarmeTripAquecimento}/>
                                    <AlarmeCP label={"Bateria CLP"} status={aRT.AlarmeBateriaCLP}/>
                                    <AlarmeCP label={"Descarga Saco de Ar"} status={aRT.AlarmeDescargaSacoDeAr}/>
                                    <AlarmeCP label={"Descarga Envelope"} status={aRT.AlarmeDescargaEnvelope}/>
                                    <AlarmeCP label={"Porta Autoclave"} status={aRT.AlarmePortaAutoclaveAberta}/>
                                    <AlarmeCP label={"Pressostato"} status={aRT.AlarmePressostato}/>
                                    <AlarmeCP label={"Termostato"} status={aRT.AlarmeTermostato}/>
                                    <AlarmeCP label={"Falha Retorno Contactora Aquecimento"} status={aRT.AlarmeFalhaRetornoContactoraAquecimento}/>
                                    <AlarmeCP label={"Risco Incendio"} status={aRT.AlarmeRiscoIncendio}/>
                                    <AlarmeCP label={"Pressao Oscilou"} status={aRT.AlarmePressaoOscilou}/>

                                </Grid>
                            </Paper>

                        </Grid>
                        {/*<Grid container style={{ alignItems:'stretch', padding: '2px' }}>*/}
                        {/*    <Button*/}
                        {/*        component={Link}*/}
                        {/*        to={`/autoclave/ciclo/${aRT.autoclaveId}/${ciclo}`}*/}
                        {/*        style={{ textAlign:'center', alignContent: 'center'}}*/}
                        {/*    >Dados do ciclo</Button>*/}
                        {/*</Grid>*/}



                    </Grid>

                    {/*// indicadores*/}
                    {/*<Grid item xs={12} sm={12} md={12} lg={8} xl={8} style={{   alignItems:'stretch', padding: '6px' }}>*/}
                    {/*    <Paper style={{  }}>*/}
                    {/*        <AutoclaveCicloGraficoIndicadores*/}
                    {/*           autoclaveId={aRT.autoclaveId}*/}
                    {/*           cicloId={aRT.ciclo}*/}
                    {/*            renderOneTime={true}*/}
                    {/*        />*/}
                    {/*    </Paper>*/}
                    {/*</Grid>*/}
                </Grid>

                <Grid item  xs={12} sm={12} md={12} lg={12} xl={12} style={{ alignItems:'stretch', padding: '2px' }}>
                    <Paper>
                        <Grid container direction="column" style={{ flex: 1, flexDirection: 'row'}}>
                       {/*///Eventos*/}
                        </Grid>
                    </Paper>
                    <Paper>
                        <Grid container direction="column" style={{ flex: 1, flexDirection: 'row'}}>
                          {/*///Alarmes*/}






                        </Grid>
                    </Paper>
                </Grid>

            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {

        autoclaves: state.autoclaves,
        pneus: state.tires
    }
}

export default connect(mapStateToProps, { getAutoclaveHistoricoIndicadores, getAutoclaveCicloSubCiclo })(withStyles(styles, {withTheme: true})(AutoclaveRealTimeInfo));


